import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

interface UsePaymentRequestDetailQuery {
    paymentRequestId: string;
}

export const useGetPaymentRequestDetailSuspense = ({ paymentRequestId }: UsePaymentRequestDetailQuery) =>
    useRepositorySuspenseQuery(
        'paymentRequests',
        'getAll',
        { paymentRequestIds: [paymentRequestId] },
        { select: (data) => data.paymentRequests?.[0] }
    );
